import R from "ramda";
import { BOOTSTRAP_ENVELOPES } from "actions/bootstrap-actions";
import {
  SET_COVERSHEET,
  SET_SEND_ENVELOPE_VISIBILITY,
  SET_REQUEST_ENVELOPE_VISIBILITY
} from "actions/envelopes-actions";

export const initialState = {
  coversheetUrl: "",
  envelopes: [],
  isLoading: true,
  isRequestEnvelopeVisible: false,
  isSendEnvelopeVisible: false
};


export const envelopesReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_ENVELOPES:
      return R.merge(state, { envelopes: action.data.envelopes });
    case SET_COVERSHEET:
      return R.merge(state, { coversheetUrl: action.data.coversheetUrl, isLoading: false });
    case SET_SEND_ENVELOPE_VISIBILITY:
      return R.merge(state, { isSendEnvelopeVisible: action.data.visibility });
    case SET_REQUEST_ENVELOPE_VISIBILITY:
      return R.merge(state, { isRequestEnvelopeVisible: action.data.visibility });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/js/reducers/envelopes-reducer.js